/**
 * Guided-planning (and self-funding modal) view of partner-shared funding sources: the
 * funding-sources rule plus the legacy shares recorded in the partner's guided session.
 */
import { usePartnerLockedFundingSources as useSharedPartnerLockedFundingSources } from '@/features/funding-sources';
import { useLegacyPartnerAllocationSelections } from './use-legacy-partner-allocation-selections';

export function usePartnerLockedFundingSources() {
  return useSharedPartnerLockedFundingSources(useLegacyPartnerAllocationSelections());
}
